import { PbDashboardUser, PbDashboardUserRoleEnum } from '@itsrever/rever-api'
import {
  AssignableRole,
  DashboardUser,
  DashboardUserRole,
  isAssignableRole
} from '@/domain/dashboard-user'

const ROLE_BY_API_VALUE: Record<string, DashboardUserRole> = {
  [PbDashboardUserRoleEnum.WriteAll]: 'ADMIN',
  [PbDashboardUserRoleEnum.ReadOnly]: 'READ_ONLY',
  [PbDashboardUserRoleEnum.Reviewer]: 'REVIEWER',
  [PbDashboardUserRoleEnum.AnalyticsOnly]: 'ANALYTICS_ONLY'
}

const API_VALUE_BY_ROLE: Record<AssignableRole, PbDashboardUserRoleEnum> = {
  ADMIN: PbDashboardUserRoleEnum.WriteAll,
  READ_ONLY: PbDashboardUserRoleEnum.ReadOnly,
  REVIEWER: PbDashboardUserRoleEnum.Reviewer,
  ANALYTICS_ONLY: PbDashboardUserRoleEnum.AnalyticsOnly
}

export function toDashboardUsers(users: PbDashboardUser[]): DashboardUser[] {
  return users.map((user) => ({
    id: user.id ?? '',
    email: user.email ?? '',
    role: toRole(user.role),
    assignedWarehouses: user.assigned_warehouses ?? [],
    accessRevoked: user.blocked ?? false
  }))
}

export function toRole(apiRole?: string): DashboardUserRole {
  // The auth middleware grants WRITE_ALL when the role claim is empty, so a user
  // without a stored role effectively is an admin; UNKNOWN would misreport it.
  if (!apiRole || apiRole === PbDashboardUserRoleEnum.Unspecified) return 'ADMIN'
  return ROLE_BY_API_VALUE[apiRole] ?? 'UNKNOWN'
}

export function toApiRole(role: string): PbDashboardUserRoleEnum {
  if (!isAssignableRole(role)) return PbDashboardUserRoleEnum.Unspecified
  return API_VALUE_BY_ROLE[role]
}
